// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__ezx5p","heading":"LearnWin_heading__5UxuT","subheading":"LearnWin_subheading__3I-+7","grid":"LearnWin_grid__kPYuS","card":"LearnWin_card__Yyx5S"};